module.exports = __webpack_public_path__ + "img/2.9e969363.png";